export default __webpack_public_path__ + "static/media/hs-logo.1dcb662a.svg";